"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DataSelectRow = /*#__PURE__*/function (_React$Component) {
  _inherits(DataSelectRow, _React$Component);

  function DataSelectRow(props) {
    var _this;

    _classCallCheck(this, DataSelectRow);

    _this = _possibleConstructorReturn(this, (DataSelectRow.__proto__ || Object.getPrototypeOf(DataSelectRow)).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.state = {
      checkedA: false,
      checkedB: false
    };
    return _this;
  }

  _createClass(DataSelectRow, [{
    key: "handleChange",
    value: function handleChange() {
      this.setState({
        checkedA: this.switchA.checked,
        checkedB: this.switchB.checked
      });
      this.props.onChange({
        name: this.props.name,
        checkedValue: this.switchA.checked ? this.switchA.value : this.switchB.value,
        uncheckedValue: !this.switchA.checked ? this.switchA.value : this.switchB.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var itemList = function itemList(list) {
        return list.map(function (item, index) {
          if (item.message) {
            return /*#__PURE__*/_react.default.createElement("p", {
              className: "message",
              key: index
            }, item.message);
          } else {
            return /*#__PURE__*/_react.default.createElement("label", {
              className: "input",
              key: index
            }, item.label, /*#__PURE__*/_react.default.createElement("span", {
              className: "input__value"
            }, item.value === '' ? '-' : item.value));
          }
        });
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "data-select-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'data-block' + (this.state.checkedA ? ' is-checked' : '') + (this.props.disabledA ? ' is-disabled' : '')
      }, !this.props.disabledA ? /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__inner"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "switch"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: this.props.idA,
        type: "radio",
        disabled: this.props.disabledA || this.props.disabledB,
        name: this.props.name,
        ref: function ref(input) {
          return _this2.switchA = input;
        },
        value: this.props.valueA,
        onChange: this.handleChange
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.props.idA,
        className: "switch__control-label"
      }, this.props.detailLinkA === '' ? /*#__PURE__*/_react.default.createElement("span", null, this.props.labelA) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.detailLinkA,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      })), this.props.labelA))), /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__data"
      }, itemList(this.props.dataA))) : /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__inner"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "data-block__placeholder-title"
      }, this.props.labelA))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'data-block' + (this.state.checkedB ? ' is-checked' : '') + (this.props.disabledB ? ' is-disabled' : '')
      }, !this.props.disabledB ? /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__inner"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "switch"
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: this.props.idB,
        type: "radio",
        disabled: this.props.disabledA || this.props.disabledB,
        name: this.props.name,
        ref: function ref(input) {
          return _this2.switchB = input;
        },
        value: this.props.valueB,
        onChange: this.handleChange
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.props.idB,
        className: "switch__control-label"
      }, this.props.detailLinkB === '' ? /*#__PURE__*/_react.default.createElement("span", null, this.props.labelB) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.detailLinkB,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      })), this.props.labelB))), /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__data"
      }, itemList(this.props.dataB))) : /*#__PURE__*/_react.default.createElement("div", {
        className: "data-block__inner"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "data-block__placeholder-title"
      }, this.props.labelB))));
    }
  }]);

  return DataSelectRow;
}(_react.default.Component);

DataSelectRow.propTypes = {
  idA: _propTypes.default.string.isRequired,
  idB: _propTypes.default.string.isRequired,
  labelA: _propTypes.default.string.isRequired,
  labelB: _propTypes.default.string.isRequired,
  valueA: _propTypes.default.any,
  valueB: _propTypes.default.any,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  disabledA: _propTypes.default.any,
  disabledB: _propTypes.default.any,
  detailLinkA: _propTypes.default.string,
  detailLinkB: _propTypes.default.string,
  dataA: _propTypes.default.any,
  dataB: _propTypes.default.any
};

var _default = (0, _translate.default)(DataSelectRow);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/resolve-duplicates/data-select-row.js
// module id = 750
// module chunks = 0